import { fetchApprovalById, fetchApprovals, insertApprovals, updateApproval } from "../../services/approval.service";
import { actionTypes } from "../contants/actionTypes"
import { logout } from "./auth";


// APPROVAL ALL

export const loadingStartApproval = () => ({
    type: actionTypes.approvalStart
});

export const loadingFinishApproval = () => ({
    type: actionTypes.approvalFinish
});

export const loadApproval = (data) => ({
    type: actionTypes.approvalLoadApproval,
    payload: {
        data: data,
    },
});

const loadApprovalError = (error) => ({
    type: actionTypes.approvalError,
    payload: error,
});


export const fetchApproval = (accessToken) => {
    return (dispatch) => {
        dispatch(loadingStartApproval());
        fetchApprovals(accessToken)
            .then((response) => {
                console.log("getApprovalById_response: ", response.data);
                dispatch(loadApproval(response.data));
            }).catch((e) => {
                console.log('error', e);
                if (e.response && e.response.status && (e.response.status === 403 || e.response.status === 401)) {
                    dispatch(logout());
                    dispatch(loadApprovalError())
                } else {
                    console.log('Ha ocurrido un error, intentálo de nuevo más tarde');
                }
            }).finally(() => {
                dispatch(loadingFinishApproval());
            });
    };
};



// INSERT APPROVAL

export const saveStartApproval = () => ({
    type: actionTypes.saveApprovalStart
});

export const saveFinishApproval = () => ({
    type: actionTypes.saveApprovalFinish
});

export const saveApproval = (data) => ({
    type: actionTypes.saveApprovalSuccess,
    payload: {
        data: data,
    },
});

export const saveErrorApproval = (error) => ({
    type: actionTypes.saveApprovalError,
    payload: { error }
});


export const savedApproval = (accessToken, data) => {
    return (dispatch) => {
        dispatch(saveStartApproval());
        insertApprovals(accessToken, data)
            .then((response) => {
                dispatch(saveApproval(response.data));
            }).catch((e) => {
                console.log('error', e);
                if (e.response && e.response.status && (e.response.status === 403 || e.response.status === 401)) {
                    dispatch(logout());
                } else {
                    dispatch(saveErrorApproval())
                    console.log('Ha ocurrido un error, intentálo de nuevo más tarde');
                }
            }).finally(() => {
                dispatch(saveFinishApproval());
            });
    };
};


// APPROVAL BY ID

export const loadingStartApprovalByID = () => ({
    type: actionTypes.approvalStartByID
});

export const loadingFinishApprovalByID = () => ({
    type: actionTypes.approvalFinishByID
});

export const loadApprovalByID = (data) => ({
    type: actionTypes.approvalLoadApprovalByID,
    payload: {
        data: data,
    },
});

const loadApprovalErrorByID = (error) => ({
    type: actionTypes.approvalErrorByID,
    payload: error,
});

export const fetchIdApproval = (accessToken, idApproval) => {
    return (dispatch) => {
        dispatch(loadingStartApprovalByID());
        fetchApprovalById(accessToken, idApproval)
            .then((response) => {
                dispatch(loadApprovalByID(response.data));
            }).catch((e) => {
                console.log('error', e);
                if (e.response && e.response.status && (e.response.status === 403 || e.response.status === 401)) {
                    dispatch(logout());
                    dispatch(loadApprovalErrorByID())
                } else {
                    console.log('Ha ocurrido un error, intentálo de nuevo más tarde');
                }
            }).finally(() => {
                dispatch(loadingFinishApprovalByID());
            });
    };
};

// UPDATE

export const loadingStartUpdateApproval = () => ({
    type: actionTypes.approvalStartUpdate
});

export const loadingFinishUpdateApproval = () => ({
    type: actionTypes.approvalFinishUpdate
});

export const loadApprovalUpdate = (data) => ({
    type: actionTypes.approvalLoadUpdate,
    payload: {
        data: data,
    },
});

const loadUpdateApprovalError = (error) => ({
    type: actionTypes.approvalErrorUpdate,
    payload: error,
});


export const updateApprovalId = (accessToken, data, idApproval) => {
    return (dispatch) => {
        dispatch(loadingStartUpdateApproval());
        updateApproval(accessToken, data, idApproval)
        .then((response) => {
            dispatch(loadApprovalUpdate(response.data));
        }).catch((e) => {
            console.log('error', e);
            if (e.response && e.response.status && (e.response.status === 403 || e.response.status === 401)) {
                dispatch(logout());
                dispatch(loadUpdateApprovalError())
            } else {
                console.log('Ha ocurrido un error, intentálo de nuevo más tarde');
            }
        }).finally(() => {
            dispatch(loadingFinishUpdateApproval());
        });
    };
};

